import { render, staticRenderFns } from "./ArchiveInvoices.vue?vue&type=template&id=77f250cc&"
import script from "./ArchiveInvoices.vue?vue&type=script&lang=js&"
export * from "./ArchiveInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveInvoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveInvoices.vue"
export default component.exports